import React from "react";
import { Box, ClassNameMap, Typography } from "@mui/material";
import { Bin } from "../../store/card/types";
import pageStyles from "./../../pages/pageStyles";
import SectionWrapper from "../pageSections/SectionWrapper";

interface ItemDetailBinData {
  bin: Bin[];
  styles: ClassNameMap;
}

const ItemDetailBinData = ({ bin, styles }: ItemDetailBinData) => {
  const classes = pageStyles();
  return (
    <>
      <hr className={styles.devide} style={{ marginBottom: "1rem" }} />
      {bin.map((data, index) => (
        <SectionWrapper title={`BIN Data ${index + 1}`} key={index} isChild>
          <Box>
            <Box mb={1}>
              <Typography display="block" className={styles.textTitle}>
                Accounts: {data.Account.join(", ")}
              </Typography>
            </Box>
            <Box mb={1} className={classes.truncate}>
              <Typography display="block" className={styles.textTitle}>
                From: {data.From}
              </Typography>
            </Box>
            <Box mb={1} className={classes.truncate}>
              <Typography display="block" className={styles.textTitle}>
                To: {data.To}
              </Typography>
            </Box>
            <Box mb={1} className={classes.truncate}>
              <Typography display="block" className={styles.textTitle}>
                Length: {data.Length}
              </Typography>
            </Box>
            <Box mb={1} className={classes.truncate}>
              <Typography display="block" className={styles.textTitle}>
                Keys:
                {data.Keys?.map((item: any) => {
                  return ` {${item.Name} , ${item.Value}} `;
                })}
              </Typography>
            </Box>
            <Box mb={1} className={classes.truncate}>
              <Typography display="block" className={styles.textTitle}>
                Floor Limit:
                {data.FloorLimit?.map((item: any) => {
                  return ` {${item.Name} , ${item.Value}} `;
                })}
              </Typography>
            </Box>
            <Box mb={1} className={classes.truncate}>
              <Typography display="block" className={styles.textTitle}>
                CardType: {data.CardType}
              </Typography>
            </Box>
            <Box mb={1} className={classes.truncate}>
              <Typography display="block" className={styles.textTitle}>
                Amount From: {data.AmountFrom}
              </Typography>
            </Box>
            <Box mb={1} className={classes.truncate}>
              <Typography display="block" className={styles.textTitle}>
                Amount To: {data.AmountTo}
              </Typography>
            </Box>
          </Box>
        </SectionWrapper>
      ))}
    </>
  );
};

export default ItemDetailBinData;
